exports.api = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    HRMSDateFormat : "YYYY-MM-DD",
}